import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineIdsPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineIdsPage',
  setup(__props) {

    document.title = "Configure IDs"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()

    const idPropertyNameForConnector = ref()
    const idPropertyNameForDataset = ref()

    const idPropertyNamesForConnector = ref([])
    const idPropertyNamesForDataset = ref([])

    const nameForConnector = ref()
    const nameForDataset = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorPropertyNamesQuery,
        useChangeIdPropertyNamesForConnectorCommand,
        useChangeIdPropertyNamesForDatasetCommand
    } = useAdminConfigurePipelineIdsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const mappings = computed(() => modelPipelineDetailsQueryV1.value?.Mappings || [])

    const { dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const propertyNames = computed(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeChangeIdPropertyNamesForConnectorCommandV1, succeedChangeIdPropertyNamesForConnectorCommandV1 } = useChangeIdPropertyNamesForConnectorCommand(id, tid, userId, idPropertyNamesForConnector)
    const { invokeChangeIdPropertyNamesForDatasetCommandV1, succeedChangeIdPropertyNamesForDatasetCommandV1 } = useChangeIdPropertyNamesForDatasetCommand(id, tid, userId, idPropertyNamesForDataset)

    function handleAddPropertyNameMappingCommand() {
        invokeAddPropertyNameMappingCommandV1()
    }

    function handleRemovePropertyNameMappingCommandV1(mapping: any) {
        invokeRemovePropertyNameMappingCommandV1({
            nameForConnector: mapping.NameForConnector,
            nameForDataset: mapping.NameForDataset,
        })
    }

    function handleAddIdPropertyNameForConnector() {
        idPropertyNamesForConnector.value.push("")
    }

    function handleRemoveIdPropertyNameForConnector(index: number) {
        idPropertyNamesForConnector.value.splice(index, 1)
    }

    function handleAddIdPropertyNameForDataset() {
        idPropertyNamesForDataset.value.push("")
    }

    function handleRemoveIdPropertyNameForDataset(index: number) {
        idPropertyNamesForDataset.value.splice(index, 1)
    }

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
        dataStream.value = modelPipelineDetailsQueryV1.value.DataStream
        idPropertyNameForConnector.value = modelPipelineDetailsQueryV1.value.IdPropertyNameForConnector ?? 'Id'
        idPropertyNameForDataset.value = modelPipelineDetailsQueryV1.value.IdPropertyNameForDataset ?? 'Id'
        idPropertyNamesForConnector.value = modelPipelineDetailsQueryV1.value.IdPropertyNamesForConnector ?? ['Id']
        idPropertyNamesForDataset.value = modelPipelineDetailsQueryV1.value.IdPropertyNamesForDataset ?? ['Id']
    })

    watch(connectorId, () => runConnectorPropertyNamesQueryV1())

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

return { __sfc: true,tid, id, connectorId, idPropertyNameForConnector, idPropertyNameForDataset, idPropertyNamesForConnector, idPropertyNamesForDataset, nameForConnector, nameForDataset, useCurrentUserQuery, usePipelineDetailsQuery, useConnectorPropertyNamesQuery, useChangeIdPropertyNamesForConnectorCommand, useChangeIdPropertyNamesForDatasetCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, direction, mappings, dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1, propertyNames, invokeChangeIdPropertyNamesForConnectorCommandV1, succeedChangeIdPropertyNamesForConnectorCommandV1, invokeChangeIdPropertyNamesForDatasetCommandV1, succeedChangeIdPropertyNamesForDatasetCommandV1, handleAddPropertyNameMappingCommand, handleRemovePropertyNameMappingCommandV1, handleAddIdPropertyNameForConnector, handleRemoveIdPropertyNameForConnector, handleAddIdPropertyNameForDataset, handleRemoveIdPropertyNameForDataset }
}

})